<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="packaging_type" name="packaging_type" rules="required" v-slot="{ errors }">
                <small class="label">Packaging type (e.g. steel drum, plastic jerrycan, etc.)</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.packaging_type" name="packaging_type" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                          val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="product_pack_size" name="product_pack_size" rules="required" v-slot="{ errors }">
                <small class="label">Product pack size (net weight)</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.product_pack_size" name="product_pack_size" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                          val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="packaging_weight" name="packaging_weight" rules="required" v-slot="{ errors }">
              <small class="label">Packaging weight</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.packaging_weight" name="packaging_weight" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="sealing_method" name="sealing_method" rules="required" v-slot="{ errors }">
              <small class="label">Sealing Method</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.sealing_method" name="sealing_method" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_tamper_seals" name="is_tamper_seals" rules=""
                                v-slot="{ errors }">
              <small class="label">Are Tamper evident seals in place?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_tamper_seals" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_tamper_seals" vid="is_tamper_seals_comment" name="is_tamper_seals_comment"
                                rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_tamper_seals_comment" name="is_tamper_seals_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_packaging_food_grade" name="is_packaging_food_grade" rules=""
                                v-slot="{ errors }">
              <small class="label">Is packaging food grade?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_packaging_food_grade" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_packaging_food_grade" vid="is_packaging_food_grade_comment" name="is_packaging_food_grade_comment"
                                rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_packaging_food_grade_comment" name="is_packaging_food_grade_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_contamination_free" name="is_contamination_free" rules=""
                                v-slot="{ errors }">
              <small class="label">Is material free from contamination?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_contamination_free" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_contamination_free" vid="is_contamination_free_comment" name="is_contamination_free_comment"
                                rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_contamination_free_comment" name="is_contamination_free_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
<!--            <ValidationProvider v-if="form.is_contamination_free" vid="is_contamination_free_file" name="is_contamination_free_file"-->
<!--                                :rules="form.is_contamination_free_file ? '' : 'file_required'" v-slot="{ errors }">-->
<!--              <small class="label">Please provide copies of migration certificates</small>-->
<!--              <a target="_blank" v-if="form.is_contamination_free_file" class="float-right" :href="form.is_contamination_free_file">view file</a>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" style="color:transparent; width:70px;" @change="onUploadContaminationFile($event)" type="file" name="is_contamination_free_file" class="w-full" :danger="errors[0]" :danger-text="errors[0]"/>-->
<!--              <span v-if="ContaminationFileRequired" class="text-danger text-sm">This field is required</span>-->
<!--            </ValidationProvider>-->
<!--            form.is_contamination_free_file is_contamination_free-->
            <small v-if="form.is_contamination_free" class="label">Please provide copies of migration certificates</small>
            <file-uploader v-on:onSetFileName="value => form.is_contamination_free_file = value" v-on:onClickFileRemove="form.is_contamination_free_file = null" :file="form.is_contamination_free_file" :condition="form.is_contamination_free"/>

          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="cleaning_in_house" name="cleaning_in_house" rules="required" v-slot="{ errors }">
              <small class="label">Is material free from phthalates?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" label="name" :reduce="option => option.value" name="is_phthalate_free" :closeOnSelect="true"
                        v-model="form.is_phthalate_free"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'N/A', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_phthalate_free === 0" vid="is_phthalate_free_comment" name="is_phthalate_free_comment" rules="required"
                                v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_phthalate_free_comment" name="is_phthalate_free_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_bisphenol_free" name="is_bisphenol_free" rules="required" v-slot="{ errors }">
              <small class="label">Is material free from bisphenol A (BPA) ?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" label="name" :reduce="option => option.value" name="is_bisphenol_free" :closeOnSelect="true"
                        v-model="form.is_bisphenol_free"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'N/A', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_bisphenol_free === 0" vid="is_bisphenol_free_comment" name="is_bisphenol_free_comment" rules="required"
                                v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_bisphenol_free_comment" name="is_bisphenol_free_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_radioactive_free" name="is_radioactive_free" rules="required" v-slot="{ errors }">
              <small class="label">Is any stainless steel used free from radioactive contamination?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" label="name" :reduce="option => option.value" name="is_radioactive_free" :closeOnSelect="true"
                        v-model="form.is_radioactive_free"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'N/A', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_radioactive_free === 0" vid="is_radioactive_free_comment" name="is_radioactive_free_comment" rules="required"
                                v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_radioactive_free_comment" name="is_radioactive_free_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_compliant_contact_food" name="is_compliant_contact_food" rules=""
                                v-slot="{ errors }">
              <small class="label">Is material compliant with Regulation (EC) No 1935/2004 on materials and articles intended to come into contact with food ?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_compliant_contact_food" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_contact_food" vid="is_compliant_contact_food_comment" name="is_compliant_contact_food_comment" rules="required"
                                v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_compliant_contact_food_comment" name="is_compliant_contact_food_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_compliant_plastic" name="is_compliant_plastic" rules="required" v-slot="{ errors }">
              <small class="label">Is material compliant with Commission Regulation (EU) No 10/2011 of 14 January 2011 on plastic materials and articles intended to come into contact with food ?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" label="name" :reduce="option => option.value" name="is_compliant_plastic" :closeOnSelect="true"
                        v-model="form.is_compliant_plastic"
                        :options="[{name: 'YES', value: 0}, {name: 'NO', value: 1}, {name: 'N/A', value: 2}]"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_plastic === 0" vid="is_compliant_plastic_comment" name="is_compliant_plastic_comment" rules="required"
                                v-slot="{ errors }">
              <small class="label">Comment</small> <br><br>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_compliant_plastic_comment" name="is_compliant_plastic_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_approved_transport" name="is_approved_transport" rules=""
                                v-slot="{ errors }">
              <small class="label">Are approved transport companies used?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_approved_transport" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_approved_transport" vid="is_approved_transport_comment" name="is_approved_transport_comment"
                                rules="required" v-slot="{ errors }">
              <small class="label">Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_approved_transport_comment" name="is_approved_transport_comment" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
<!--            <ValidationProvider v-if="form.is_approved_transport" vid="is_approved_accreditations" name="is_approved_accreditations"-->
<!--                                :rules="form.is_approved_accreditations ? '' : 'file_required'" v-slot="{ errors }">-->
<!--              <small class="label">Please provide details, together with copies of any accreditation held</small>-->
<!--              <a target="_blank" v-if="form.is_approved_accreditations" class="float-right" :href="form.is_approved_accreditations">view file</a>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" style="color:transparent; width:70px;" type="file" @change="onUploadApprovedAccreditaionFile($event)" name="is_approved_accreditations" class="w-4/5" :danger="errors[0]" :danger-text="errors[0]"/>-->
<!--              <span v-if="ApprovedAccreditaionFileRequired" class="text-danger text-sm">This field is required</span>-->
<!--            </ValidationProvider>-->
<!--            form.is_approved_accreditations-->
            <small v-if="form.is_approved_transport" class="label">Please provide details, together with copies of any accreditation held</small>
            <file-uploader-not-required v-on:onSetFileName="value => form.is_approved_accreditations = value" v-on:onClickFileRemove="form.is_approved_accreditations = null" :file="form.is_approved_accreditations" :condition="form.is_approved_transport"/>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="no_touch_points" name="no_touch_points" rules="required" v-slot="{ errors }">
              <vx-tooltip
                color="primary"
                position="left"
                text="Example: Grower → Transport → Manufacturer → Transport → Packer → Transport = 6">
                <small class="label">Number of touch points</small>
              </vx-tooltip>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.no_touch_points" name="no_touch_points" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="detail_touch_points" name="detail_touch_points" rules="required" v-slot="{ errors }">
              <small class="label">Details of touch points</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" v-model="form.detail_touch_points" type="text" name="detail_touch_points" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_packaging_transport_complete" button="submit"
                     class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes
          </vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_tamper_seals: false,
          is_packaging_food_grade: false,
          is_contamination_free: false,
          is_compliant_contact_food: false,
          is_approved_transport: false,
          is_phthalate_free: 2,
          is_bisphenol_free: 2,
          is_radioactive_free: 2,
          is_compliant_plastic: 2
        },
        id: null,
        status: {},
        ContaminationFileRequired: false,
        ApprovedAccreditaionFileRequired: false,
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_packaging_transport_complete ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (this.form.is_contamination_free && !this.form.is_contamination_free_file || this.form.is_approved_transport && !this.form.is_approved_accreditations ) {
          if (this.form.is_contamination_free && !this.form.is_contamination_free_file) {
            this.ContaminationFileRequired = true
          }
          if(this.form.is_approved_transport && !this.form.is_approved_accreditations) {
            this.ApprovedAccreditaionFileRequired = true
          }
        } else {
          this.$vs.loading();
          try {
            const data = (await SupplierRawMaterialRepository.UpdateRawMaterialPackagingTransport(this.id, this.form));
            this.showSuccessMessage('Raw Material Packaging & Transport Details Updated!');
            this.onClickNext()
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onClickCreate() {
        if (this.form.is_contamination_free && !this.form.is_contamination_free_file || this.form.is_approved_transport && !this.form.is_approved_accreditations ) {
          if (this.form.is_contamination_free && !this.form.is_contamination_free_file) {
            this.ContaminationFileRequired = true
          }
          if(this.form.is_approved_transport && !this.form.is_approved_accreditations) {
            this.ApprovedAccreditaionFileRequired = true
          }
        } else {
          this.$vs.loading();
          try {
            const data = (await SupplierRawMaterialRepository.CreateRawMaterialPackagingTransport(this.form));
            this.showSuccessMessage('Raw Material Packaging & Transport Details Created!');
            this.onClickNext()
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onUploadContaminationFile(event, model_name) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_contamination_free_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.ContaminationFileRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadApprovedAccreditaionFile(event, model_name) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_approved_accreditations = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.ApprovedAccreditaionFileRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadData() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialPackagingTransport(this.id)).data;
        this.form = data;
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data;
        this.status = data;
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_packaging_transport_complete) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
